import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { AngularFireStorage } from '@angular/fire/storage';
import { Utils } from 'src/app/core/resources/utils';
import * as _ from 'lodash';
import { CargoPayment } from 'src/app/core/interfaces/cargoPayment';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { Observable, Subscription, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { CargoDetailService } from '../cargo-detail/cargo-detail.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { FormVehicleComponent } from '../../administration/vehicles/form-vehicle/form-vehicle.component';
import { DialogComponent } from 'src/app/shared/dialog/dialog.component';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import { Dialog } from 'src/app/core/resources/dialog';
import { CargoManager, VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE } from 'src/app/core/managers/cargo.manager';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Permission } from 'src/app/core/resources/permission';
import { User } from 'src/app/core/interfaces/user';
import { AccountService } from '../../account/account.service';
import { VehicleMessages } from 'src/app/core/messages/vehicle-messages.enum';
import { Fmt } from 'src/app/core/messages/fmt';
import { VehiclesService } from '../../administration/vehicles/list-vehicles.service';
import { Router } from '@angular/router';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { TRIP_TYPES } from 'src/app/core/enums/tripTypes.enum';
import { AdminUsersService } from '../../administration/admin-users/admin-users.service';
import { environment } from 'src/environments/environment';
import { Roles } from 'src/app/core/enums/roles.enum';
import { UserManager } from 'src/app/core/managers/user.manager';
import { Company } from 'src/app/core/interfaces/company';
import { AssignVehicle } from 'src/app/core/interfaces/assignVehicle';
import { VehicleCreateResponse } from 'src/app/core/interfaces/vehicleCreateResponse';
import { CargoService } from 'src/app/core/services/cargo.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { TurnMatch } from 'src/app/core/interfaces/turnMatch';
import { DateManager } from 'src/app/core/managers/date.manager';
import { ServiceType } from 'src/app/core/interfaces/serviceType';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { ChangeDriverComponent } from '../change-driver/change-driver.component';
import { InputLicensePlateTrailerComponent } from 'src/app/shared/input-license-plate-trailer/input-license-plate-trailer';
import { TrailerVehicleComponent } from '../../administration/vehicles/trailer-vehicle/trailer-vehicle.component';
import { Trailer } from 'src/app/core/interfaces/trailer';
import { CargoStateEnum } from 'src/app/core/enums/cargoState.enum';
import { RequestTermsDialogComponent } from '../../administration/request-terms-dialog/request-terms-dialog.component';
import { Companies } from 'src/app/core/resources/companies';
import { FreightListService } from '../cargo-list/cargo-list.service';
import { VehicleAssignManager } from 'src/app/core/managers/vehicle-assign.manager';
import { DetailVehicleComponent } from '../../administration/vehicles/detail-vehicle/detail-vehicle.component';

@Component({
  selector: 'app-assign-vehicle-cargo',
  templateUrl: './assign-vehicle-cargo.component.html',
  styleUrls: ['./assign-vehicle-cargo.component.scss'],
  providers: [AuthService, Global, CargoManager, UserManager]
})

export class AssignVehicleCargoComponent implements OnInit {

  assignVehicleForm: FormGroup;
  @Input() cargo: Cargo;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onAssignVehicle: EventEmitter<any> = new EventEmitter();
  listVehicles: Observable<Vehicle[]>;
  filteredOptions: Observable<string[]>;
  vehicleSelected: Vehicle;
  trailerSelected: Trailer;
  userActive = this.authService.getUserSession().information;
  permission = Permission;
  mask: string = '';
  vehicleInfo: Vehicle;
  type: string = '';
  assignVehicleCargoComponent: AssignVehicleCargoComponent;
  licensePLate: string;
  vehicle: Vehicle;
  invalidVehicle: boolean = true;
  holderCompany: string;
  filterMatchDate = new FormControl(null);
  dateOptions = {
    lastWeek: 'dddd [pasado]',
    sameElse: 'L'
  };
  matchDateOptions = [
    {
      alias: 'Hoy',
      value: new Date()
    },
    {
      alias: 'Ayer',
      value: DateManager.substract(new Date(), 1, 'days')
    },
    {
      alias: DateManager.getCalendar(DateManager.substract(new Date(), 2, 'days'), null, this.dateOptions),
      value: DateManager.substract(new Date(), 2, 'days')
    },
  ];
  filterNumberOfTrips = new FormControl(null);
  numberOfTripsOptions = [
    { alias: 'Ningún viaje', value: 'zero' },
    { alias: '1 a 5 viajes', value: 'to five' },
    { alias: 'Más de 5 viajes', value: 'from six' },
  ];
  allowCreatingWithoutTruora: boolean = false;
  userStateByValidationRules: { active: boolean, description: string } = { active: false, description: '' };
  constructor(
    public dialogRef: MatDialogRef<AssignVehicleCargoComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogParams: {
      cargo?: Cargo,
      filteredCargosTurns?: {
        cargoConsecutive?: number,
        matches?: TurnMatch[]
      },
      title?: string,
      type?: string,
      licensePlate?: string,
    },
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private userManager: UserManager,
    private freightForwarderDetailService: CargoDetailService,
    public utils: Utils,
    public matDialog: MatDialog,
    public dialog: Dialog,
    private cargoManager: CargoManager,
    private permissionRole: PermissionRole,
    private accountService: AccountService,
    private vehiclesService: VehiclesService,
    private router: Router,
    private adminUsersService: AdminUsersService,
    private cargoService: CargoService,
    public service: CargoDetailService,
    private companyService: CompanyService,
    private cargoListService: FreightListService,
    private vehicleAssignManager: VehicleAssignManager
  ) {
    if (this.dialogParams) {
      if (this.dialogParams.cargo) this.cargo = this.dialogParams.cargo;
      if (this.dialogParams.type) this.type = this.dialogParams.type;
    }
  }
  /**
  * This method evaluates if type is assign or not.
  */
  ngOnInit() {
    this.infoTruora();
    if (this.type === 'assign' || this.cargo)
      this.createAssignVehicleForm();
    this.holderCompany = this.authService && this.authService.getUserSession() && this.authService.getUserSession().clientCompanyId ? this.authService.getUserSession().clientCompanyId : null;
  }

  private infoTruora() {
    const holderCompany = this.companyService.holderCompany;
    if (holderCompany && holderCompany.companyId)
      this.allowCreatingWithoutTruora = !!(holderCompany && holderCompany.allowCreatingWithoutTruora);
  }
  /**
  * This method allows to create the required form to assign the vehicle to a load.
  */
  createAssignVehicleForm() {

    this.assignVehicleForm = new FormGroup({
      idCargo: new FormControl(
        this.cargo.id,
        Validators.compose(
          [Validators.required]
        )
      ),
      idUser: new FormControl(
        null,
        Validators.compose(
          [Validators.required]
        )
      ),
      idVehicle: new FormControl(
        '',
        Validators.compose(
          [Validators.required]
        )
      )
    });

    this.listVehicles = this.assignVehicleForm.controls.idVehicle.valueChanges
      .pipe(
        startWith(''),
        // debounceTime(400),
        distinctUntilChanged(),
        switchMap((val: string | Vehicle) => {
          if (!val || typeof val !== 'string') return of([]);
          try {
            if (typeof val === 'string' && val.trim().length > 2) {
              return this.filter(val);
            } else {
              this.vehicleSelected = null;
              this.trailerSelected = null;
              return [];
            }
          } catch (e) {
            return [];
          }
        })
      );

    if (this.dialogParams && this.dialogParams.licensePlate)
      this.getDetailLicensePlate(this.dialogParams.licensePlate);
  }

  private async getDetailLicensePlate(licensePlate: string): Promise<void> {
    this.spinner.show();
    try {
      const vehicleDetail = await this.vehiclesService.getVehicleFromOwnCompany(licensePlate).toPromise();
      if (vehicleDetail && vehicleDetail.id) {
        if (vehicleDetail.trailerId)
          this.trailerSelected = await this.getDetailTrailer(vehicleDetail.trailerId);
        this.vehicleSelected = vehicleDetail;
      } else {
        this.snackBarService.openSnackBar('No se encontró el vehículo', undefined, 'error');
        this.vehicleSelected = null;
        this.trailerSelected = null;
      }
    } catch (error) {
      this.snackBarService.openSnackBar('No se encontró el vehículo', undefined, 'error');
      this.vehicleSelected = null;
      this.trailerSelected = null;
    }
    this.spinner.hide();
  }
  /**
  * This method consumes a service that search matches of a vehicle in the BD with the license plata typed.
  * @param {string} value (string) is the license plate write by the user.
  * @returns {Observable<Vehicle[]>} (Observable<Vehicle[]>) returns a vehicle object if exists.
  */
  filter(value: string): Observable<Vehicle[]> {
    const filterValue = value.toUpperCase();
    if (this.holderCompany !== null) {
      return this.vehiclesService.getVehiclesFromOwnCompany(filterValue)
        .pipe(
          map(response => {
            if (response && response.length) {
              return response.filter(option => {
                return option.id.toLowerCase().indexOf(filterValue.toLowerCase()) === 0;
              })
            } else {
              return [];
            }
          }
          )
        );
    } else return of([]);
  }
  /**
  * This method set some information according to the selection of the user.
  * @param {any} $event (any) is the information of the selected vehicle.
  */
  async optionSelected(vehicle: Vehicle) {
    this.spinner.show();
    if (vehicle && vehicle.id && vehicle.trailerId)
      this.trailerSelected = await this.getDetailTrailer(vehicle.trailerId);
    this.vehicleSelected = vehicle;
    this.spinner.hide();
  }
  /**
  * This method open a dialog window to fill the fields necessaries to create a vehicle.
  */
  openDialogCreateVehicle() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      company: {
        exclusive: this.cargo.exclusive,
        nit: this.cargo.idCompany
      },
      cargoId: this.cargo.id
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.matDialog.open(FormVehicleComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.state) {
        const vehicleCreateResponse: VehicleCreateResponse = result.value;
        this.vehicleSelected = vehicleCreateResponse.vehicle;
        this.onSubmit();
      } else if (result && !result.state) {
        this.snackBarService.openSnackBar('Ocurrió un error al asignar el vehículo', undefined, 'error');
      }
    });
  }

  getMatchIndex(match: TurnMatch): number {
    if (!this.dialogParams || !this.dialogParams.filteredCargosTurns || !this.dialogParams.filteredCargosTurns.matches)
      return 0;
    const index = this.dialogParams.filteredCargosTurns.matches.findIndex(mat => mat.id === match.id);
    if (index !== -1) return index + 1;
    return 0;
  }

  get cargoMatchesFiltered(): TurnMatch[] {
    if (!this.dialogParams || !this.dialogParams.filteredCargosTurns || !this.dialogParams.filteredCargosTurns.matches)
      return [];
    let matches = this.dialogParams.filteredCargosTurns.matches;
    if (this.filterMatchDate.value) {
      matches = matches.filter(match => DateManager.isSame(this.filterMatchDate.value, DateManager.stringToDate(match.date)));
    }
    if (this.filterNumberOfTrips.value) {
      const trips = this.filterNumberOfTrips.value;
      matches = matches.filter(match => {
        return match && this.utils.isDefined(match.numberOfTrips) &&
          ((trips === 'zero' && match.numberOfTrips === 0) ||
            (trips === 'to five' && match.numberOfTrips && match.numberOfTrips <= 5) ||
            (trips === 'from six' && match.numberOfTrips && match.numberOfTrips > 5));
      });
    }
    return matches;
  }
  /**
  * This method verify if the vehicle has driver.
  * @param {Vehicle} vehicle (Vehicle) is the information of the vehicle.
  * @returns {boolean} (boolean) returns if has or not driver.
  */
  hasDriver(vehicle: Vehicle): boolean {
    return !!(vehicle && vehicle.driver && vehicle.driver.document && vehicle.driver.name);
  }

  /**
  * This method consumes the service to assign a vehicle to a load.
  * @param {AssignVehicle} params (AssignVehicle) is the information neccesary to bring the vehicle and driver information.
  * @param {string} type (string - optional) if is turn o common assign vehicle.
  */
  private assignVehicleToCargo(params: AssignVehicle, type?: string, overrideRiskValidation?: boolean) {
    this.spinner.show();
    this.freightForwarderDetailService.acceptCargo(params).subscribe(
      () => {
        this.cleanErrorFromExcel();
        this.belowSicetac(this.cargo, type, params);
      },
      async (error) => {
        this.spinner.hide();
        const isRiskValidationBlocked = this.utils.getNestedValue(error, 'error.code') === VEHICLE_TRIP_VALIDATION_EXCEPTION_CODE;
        if (isRiskValidationBlocked && !overrideRiskValidation) {
          const message = this.utils.getNestedValue(error, 'error.message');
          const { continueAnyway } = await this.cargoManager.showRiskValidationBlockedDialog(message);
          if (continueAnyway) {
            return this.assignVehicleToCargo({ ...params, assignVehicleFullAccess: true }, type, true);
          }
          return;
        }
        // El backend valida reglas de negocio (ej. viajes mínimos del vehículo según el perfil de
        // riesgo del servicio) y devuelve el motivo en el body. Se muestra en el modal de error, no en
        // un snackbar, para que el usuario alcance a leer por qué no se pudo asignar.
        const hasBackendMessage = !this.utils.isEmpty(error) && !this.utils.isEmpty(error.error) &&
          !this.utils.isEmpty(error.error.message);
        if (hasBackendMessage) {
          this.openModalDialogError(`No es posible asignar el vehículo ${params.licensePlate}`, error.error.message);
          return;
        }
        this.snackBarService.openSnackBar('Ocurrió un error al asignar el vehículo ' + params.licensePlate, undefined, 'error');
      }
    );
  }
  /**
  * This method close the assign vehicle modal.
  */
  closeModal() {
    this.assignVehicleForm.reset();
    this.dialogRef.close({ state: false })
  }

  /**
  * @returns {boolean} Returns true if the user is from Teclogi
  * @description Verifies if the user is from Teclogi
  */
  public get isTeclogiUserOrClient(): boolean {
    return this.authService && this.authService.getCompanySaaS() &&
      Companies.companiesNIT.TECLOGI === this.authService.getCompanySaaS().companyId;
  }

  /**
  * This method validates all the conditions necessary to assign a vehicle.
  * @param {string} type (string - optional) if is turn o common assign vehicle.
  */
  async onSubmit(type?: string, overrideRiskValidation?: boolean) {
    if (!this.vehicleSelected || !this.vehicleSelected.id)
      return this.snackBarService.openSnackBar('No se ha seleccionado un vehículo', undefined, 'error');
    this.spinner.show();
    const vehicleAssignValidationResults = await this.vehicleAssignManager.validateVehiclesForAssign(
      [this.vehicleSelected.id], this.cargo, overrideRiskValidation
    );
    this.spinner.hide();
    const { isValid, message, missingInfo, driver, licensePlate, termsUnaccepted, riskValidationBlocked } = vehicleAssignValidationResults[0];

    if (!isValid) {
      if (termsUnaccepted) return this.openModalRequestTerms(driver);
      if (missingInfo) return this.openModalMissingInfo(missingInfo);
      if (riskValidationBlocked) {
        const { continueAnyway } = await this.cargoManager.showRiskValidationBlockedDialog(message);
        if (continueAnyway) return this.onSubmit(type, true);
        return;
      }
      return this.openModalDialogError(`Error al asignar el vehículo ${licensePlate}`, message);
    }
    const inspection = await this.cargoManager.modalPreoperationalInspection(
      this.cargo,
      licensePlate,
      'Se requiere realizar una inspección preoperacional del vehículo para su confirmación. ¿Desea realizar la inspección ahora o delegarla al conductor?')
    if (!inspection) return;

    const body: AssignVehicle = {
      cargoId: this.cargo.id,
      applicantId: driver.information.document,
      licensePlate: licensePlate,
      assignVehicleFullAccess: !!overrideRiskValidation
    };
    this.assignVehicleToCargo(body, type, overrideRiskValidation);
  }

  private openModalRequestTerms(driver: User) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      name: driver.information.name,
      document: driver.information.document,
      phone: driver.phone,
      user: driver
    };
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    this.matDialog.open(RequestTermsDialogComponent, dialogConfig);
  }

  private openModalMissingInfo(missingInfo: { missingDocuments: string[], unacceptedDocuments: string[], invalidReferences: string[] }) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { title: "Error en la Información obligatoria del Vehículo", hideBtnConfirm: true };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.data.descriptionHTML = '';
    if (missingInfo.missingDocuments.length) {
      let missingDocumentsMessage = '';
      missingInfo.missingDocuments.forEach(document => missingDocumentsMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_DOCUMENTATION_INCOMPLETE}</p><ol>${missingDocumentsMessage}</ol>`;
    }
    if (missingInfo.unacceptedDocuments.length) {
      let unacceptedDocumentsMessage = '';
      missingInfo.unacceptedDocuments.forEach(document => unacceptedDocumentsMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_DOCUMENTATION_UNACCEPTED}</p><ol>${unacceptedDocumentsMessage}</ol>`;
    }
    if (missingInfo.invalidReferences.length) {
      let invalidReferencesMessage = '';
      missingInfo.invalidReferences.forEach(document => invalidReferencesMessage += `<li>${document}</li>`);
      dialogConfig.data.descriptionHTML += `<p>${VehicleMessages.VEHICLE_REFERENCES_UNACCEPTED}</p><ol>${invalidReferencesMessage}</ol>`;
    }
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  public openModalDialogError(title: string, description?: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: title,
      iconError: true,
      descriptionHTML: `<p class="text-center">${description}</p>`,
      hideBtnConfirm: true
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.matDialog.open(DialogComponent, dialogConfig);
  }

  get isEscortedService(): boolean {
    return this.utils.isEscortedService(this.cargo);
  }

  /**
  * This method consumes the service that brings the information of the vehicle.
  * @param {string} licensePLate (string) is the license plate of the vehicle on request.
  * @param {Cargo} needResponse (Cargo - optional) is the information of the load.
  */
  async getVehicleInfo(licensePLate: string): Promise<{ canContinue: boolean }> {
    this.spinner.show();
    let vehicleInfo: Vehicle;
    try {
      vehicleInfo = await this.vehiclesService.getVehicleFromOwnCompany(licensePLate).toPromise();
    } catch (error) { }
    this.spinner.hide();
    if (!vehicleInfo) {
      this.snackBarService.openSnackBar(`No se encontró el vehículo ${licensePLate}`, undefined, 'error');
      return { canContinue: false };
    }
    await this.assignTovehicleSelected(vehicleInfo);
    return { canContinue: true };
  }
  /**
  * This method assign the information of the vehicle selected and the people associate.
  * @param {Vehicle} vehicleInfo (Vehicle) is the information of the vehicle selected.
  */
  async assignTovehicleSelected(vehicleInfo: Vehicle) {
    if (this.utils.getNestedValue(vehicleInfo, 'trailerId'))
      this.trailerSelected = await this.getDetailTrailer(this.utils.getNestedValue(vehicleInfo, 'trailerId'));
    this.vehicleSelected = vehicleInfo;
  }

  public async openVehicleDetail(licensePlate: string): Promise<void> {
    this.spinner.show();
    let vehicle: Vehicle;
    try {
      vehicle = await this.vehiclesService.getVehicleFromOwnCompany(licensePlate).toPromise();
    } catch (error) {
      vehicle = null;
    } finally {
      this.spinner.hide();
    }
    if (!vehicle) return this.snackBarService.openSnackBar('No fue posible obtener la información del vehículo', undefined, 'error');
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: vehicle,
      close: true,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    await this.matDialog.open(DetailVehicleComponent, dialogConfig).afterClosed().toPromise();
    this.getDetailLicensePlate(licensePlate);
  }

  public changeDriver(type?: 'change' | 'assign'): void {

    const formControl = new FormControl();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: `${type === 'change' ? 'Modificación' : 'Asignación'} de conductor`,
      label: 'Ingresa el número de documento',
      idVehicle: this.vehicleSelected.id,
      options: {
        typeUser: 'driver',
      },
      inputFormControl: formControl
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.autoFocus = false;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const modalDialog = this.matDialog.open(ChangeDriverComponent, dialogConfig);
    modalDialog.afterClosed().subscribe(result => {
      if (result && result.state && result.data) {
        this.vehicleChangeDriver(result.data, result.securityStudyValidation);
      }
    });
  }

  private vehicleChangeDriver(user: User, securityStudyValidation: boolean): void {
    this.spinner.show();
    this.vehiclesService.vehicleChangeDriver(this.vehicleSelected.id, user, securityStudyValidation).toPromise()
      .then((success: User) => {
        const data = this.userManager.sanitizeUser(success, Roles.DRIVER);
        if (data) {
          if (data.errorRNDC && data.errorRNDC && data.errorRNDC.error === 'Debe ingresar un conductor diferente al actual')
            this.snackBarService.openSnackBar(data.errorRNDC.error, undefined, 'alert');
          else {
            this.snackBarService.openSnackBar('Conductor asignado correctamente');
            this.getDetailLicensePlate(this.vehicleSelected.id);
          }
        } else {
          this.snackBarService.openSnackBar('Ocurrió un error al cambiar de conductor', undefined, 'error');
        }
      })
      .catch((error) => {
        this.snackBarService.openSnackBar('Ocurrió un error al cambiar de conductor', undefined, 'error');
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  /**
  * @description Opens a modal to change the trailer, depending of result executes "openDialogCreateTrailer" or "vehicleChangeTrailer" methods
  */
  changeTrailer() {
    const formControl = new FormControl();
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: "Ingresa la placa del trailer",
      dialog: true,
      options: { autocomplete: true },
      inputFormControl: formControl,
    };
    dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.matDialog.open(InputLicensePlateTrailerComponent, dialogConfig).afterClosed().subscribe((result) => {
      if (result && result.state) {
        if (result.data === null)
          this.openDialogCreateTrailer();
        else if (this.utils.isDefined(result.data))
          this.vehicleChangeTrailer(this.vehicleSelected.id, result.data);
      }
    });
  }

  /**
  * @description Opens a modal to create new trailer and updates the vehicle trailer with modal result
  */
  private openDialogCreateTrailer() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      updateTrailer: true,
      vehicle: this.vehicle,
    };
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.matDialog.open(TrailerVehicleComponent, dialogConfig).afterClosed().subscribe(async (result) => {
      if (result && result.state && result.trailerId) {
        const trailer = await this.getDetailTrailer(result.trailerId);
        if (trailer) this.vehicleChangeTrailer(this.vehicleSelected.id, trailer);
      }
    });
  }

  /**
  * @description Gets the trailer's detail from backend service
  */
  private async getDetailTrailer(trailerId: string): Promise<Trailer> {
    try {
      const trailers: Trailer[] = await this.vehiclesService.getTrailerList(`?id=${trailerId}`).toPromise();
      return trailers && trailers.length ? trailers[0] : null;
    } catch (error) {
      return null;
    }
  }

  /**
  * @description Changes the vehicle's trailer with backend service
  */
  private async vehicleChangeTrailer(licensePlate: string, trailer: Trailer) {
    const loadingCargos = await this.findLoadingCargosByTrailer(trailer.id, licensePlate);
    if (loadingCargos && loadingCargos.length) {
      const description = this.getTrailerServicesInRouteDescription(loadingCargos);
      if (!this.permissionRole.hasPermission(this.permission.administration.module, this.permission.administration.reassignTrailer))
        return this.cargoManager.openDialogError(
          ServiceMessages.TRAILER_HAS_SERVICES_IN_ROUTE,
          description
        );
      const result = await this.cargoManager.openDialogConfirm(ServiceMessages.TRAILER_HAS_SERVICES_IN_ROUTE, description);
      if (!result.confirm) return;
    }
    this.spinner.show();
    this.vehiclesService.updateTrailer(trailer, licensePlate).toPromise()
      .then(() => this.getDetailLicensePlate(licensePlate))
      .catch((error) => {
        if (error && error.errorRNDC && error.errorRNDC.error)
          this.snackBarService.openSnackBar(error.errorRNDC.error, undefined, "error");
        else
          this.snackBarService.openSnackBar("Ocurrió un error al cambiar de trailer", undefined, "error");
      })
      .finally(() => this.spinner.hide())
  }

  private getTrailerServicesInRouteDescription(loadingCargos: Cargo[]): string {
    const serviceIds = loadingCargos
      .map(cargo => cargo && cargo.consecutive ? cargo.consecutive.toString() : '')
      .filter(serviceId => !!serviceId);
    let previewServiceIds = serviceIds.slice(0, 4).join(', ');
    if (serviceIds.length > 4)
      previewServiceIds += ' y mas';
    return Fmt.string(ServiceMessages.TRAILER_HAS_SERVICES_IN_ROUTE_WITH_IDS, previewServiceIds);
  }

  async findLoadingCargosByTrailer(trailerId: string, licensePlate: string): Promise<Cargo[]> {
    try {
      this.spinner.show();
      let filters = '';
      filters += `&state=${encodeURIComponent('Start service')}`;
      filters += `&trailerId=${encodeURIComponent(trailerId.trim())}`;
      const response = await this.cargoListService.getListCargo(filters).toPromise();
      const cargos = response.results;
      this.spinner.hide();
      if (!cargos || !cargos.length) return [];
      const cargosWithDiffVehicle = cargos.filter(cargo => cargo.licensePlate !== licensePlate && !cargo.trailerReassignedFingerprint);
      return cargosWithDiffVehicle;
    } catch (error) {
      this.spinner.hide();
      return [];
    }
  }

  get assignTurnVehicles(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.assignTurnVehicles);
  }

  private cleanErrorFromExcel() {
    if (!this.cargo || !this.cargo.errorFieldsExcelCargo ||
      !this.cargo.errorFieldsExcelCargo.licensePlate ||
      this.cargo.state !== 'Request')
      return;

    let data = { id: this.cargo.id, state: this.cargo.state };
    if (this.cargo.errorFieldsExcelCargo) {
      data['errorFieldsExcelCargo'] = this.cargo.errorFieldsExcelCargo;
      data['errorFieldsExcelCargo']['licensePlate'] = null;
    }
    const $updateCargoFeature = this.service.completeUpdateRequest(data, this.cargo).subscribe({
      next: (success) => { },
      error: (error) => console.error(error),
      complete: () => $updateCargoFeature.unsubscribe()
    });
  }

  private belowSicetac(cargo: Cargo, type?: string, params?: AssignVehicle) {
    const formatter = new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true,
    });
    if (this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.approvedBelowSicetac)) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
      dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      dialogConfig.autoFocus = false;
      dialogConfig.disableClose = true;
      this.spinner.show();
      this.service.detailCargoByConsecutive(cargo.consecutive.toString()).subscribe(
        (data: any) => {
          this.spinner.hide();
          cargo = data;
          if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
            const min = formatter.format(cargo.minimumApprovedValueSicetac);
            dialogConfig.data = {
              title: 'Desea aprobar el flete por debajo del SICETAC',
              description: `El flete mínimo es ${min}, por favor realice una bonificación para ajustarse al valor mínimo permitido`,
              btnDetailCargo: true,
              path: this.cargo.state === CargoStateEnum.REQUEST
                ? `service-request-form/menu-service/${this.cargo.consecutive}`
                : `cargo/detail/${this.cargo.consecutive}`,
              closeModal: true,
            };
            const dialogRef = this.matDialog.open(DialogComponent, dialogConfig);
            dialogRef.afterClosed().subscribe(result => {
              if (result && result.state) {
                this.cargoService.approvedBelowSiceTac(cargo.id).subscribe(
                  () => {
                    this.snackBarService.openSnackBar("Se aprobó con éxito", undefined, 'success');
                  },
                  (error) => {
                    this.snackBarService.openSnackBar("No se pudo aprobar", undefined, 'error');
                  }
                );
              } else {
                this.snackBarService.openSnackBar("No se pudo aprobar", undefined, 'error');
              }
            })
          }
        }
      );
    } else {
      if (cargo.belowSicetac && !cargo.freightValueApprovedBelowSicetac) {
        const min = formatter.format(cargo.minimumApprovedValueSicetac);
        this.snackBarService.openSnackBar(`El flete mínimo es ${min}, por favor realice una bonificación para ajustarse al valor mínimo permitido`, undefined, 'alert');
      }
    }
    if (this.onAssignVehicle) this.onAssignVehicle.emit();
    this.spinner.hide();
    if (this.dialogRef) this.dialogRef.close({ state: true });
    this.snackBarService.openSnackBar('Se ha asignado el vehículo ' + params.licensePlate + ' correctamente');
  }


  async getDetailUserByDocument(userDocument: string): Promise<User> {
    this.spinner.show();
    let user: User;
    try { user = await this.adminUsersService.getUsersDetailByDocument(userDocument).toPromise(); }
    catch (error) { }
    this.spinner.hide();
    return user ? user : null;
  }

  displayWith(vehicle: Vehicle | string): string {
    if (typeof vehicle === 'string') {
      return vehicle;
    }
    return vehicle && vehicle.id ? vehicle.id : '';
  }

  returnWith(vehicle: Vehicle | string): string {
    if (typeof vehicle === 'string') {
      return vehicle;
    }
    return vehicle && vehicle.id ? vehicle.id : '';
  }
}
